import { create as n } from "zustand";
const m = {
  legendItems: [],
  legendItemsBackUp: []
}, d = n((t) => ({
  ...m,
  onSetLegendItems: (e) => t(() => ({
    legendItems: e
  })),
  onBackupLegendItems: () => t((e) => ({
    legendItemsBackUp: e.legendItems
  })),
  onRestoreLegendItems: () => t((e) => ({
    legendItems: e.legendItemsBackUp
  }))
}));
export {
  d as useMapLegendStore
};
//# sourceMappingURL=index.es158.js.map
